import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=00503ffb&scoped=true&"
import script from "./DoughnutChart.vue?vue&type=script&lang=ts&"
export * from "./DoughnutChart.vue?vue&type=script&lang=ts&"
import style0 from "./DoughnutChart.vue?vue&type=style&index=0&id=00503ffb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00503ffb",
  null
  
)

export default component.exports